// src/app/services/payment.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private apiUrl = environment.API_PAYMENT;
  private apiKeyUrl = environment.API_GENERATE_KEY;

  constructor(private http: HttpClient) { }

  createWithdrawal(encryptedData: string, apiKey: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-api-key': apiKey,
      'Content-Type': 'application/json'
    });

    const body = { encryptedData };

    return this.http.post(this.apiUrl, body, { headers: headers });
  }


  generateApiKey(key: string): Observable<any> {
    return this.http.post(this.apiKeyUrl, { data: key });
  }
}
